// ═══════════════════════════════════════════════
// 日本語翻訳
// ═══════════════════════════════════════════════
const ja = {
  lang: 'ja',
  langName: '日本語',
  currency: '¥',
  currencyRate: 0.11, // ₩1 ≈ ¥0.11

  // アプリ全体
  app: {
    title: '資材管理 ERP',
    subtitle: 'AI搭載スマート資材管理システム',
    poweredBy: 'Powered by WindyFlo',
  },

  // サイドバー
  sidebar: {
    dashboard: 'ダッシュボード',
    materials: '資材管理',
    inventory: '在庫状況',
    orders: '受注管理',
    suppliers: 'サプライヤー',
    reports: 'レポート',
    settings: '設定',
    admin: '管理者',
    sysAdmin: 'システム管理者',
    expand: '展開',
    collapse: '折りたたむ',
  },

  // トップバー
  topbar: {
    searchPlaceholder: '資材・受注・在庫を検索...',
    notifications: '通知',
    markAllRead: 'すべて既読',
    viewAll: 'すべての通知を表示',
    profile: 'プロフィール',
    settings: '設定',
    logout: 'ログアウト',
    notif1: '在庫不足アラート：A-101品目',
    notif2: '新規受注：PO-2024-001',
    notif3: '月次レポート作成完了',
    timeAgo1: '5分前',
    timeAgo2: '30分前',
    timeAgo3: '1時間前',
  },

  // ダッシュボード
  dashboard: {
    title: 'ダッシュボード',
    totalItems: '品目数',
    totalInventory: '総在庫量',
    needOrder: '要発注',
    totalLoss: '不良損失',
    invStatus: '在庫ステータス分布',
    statusNormal: '正常',
    statusWarning: '注意',
    statusOrder: '要発注',
    alertTitle: '緊急アラート',
    alertNeedOrder: '要発注品目',
    alertItems: '品目が在庫不足です。',
    alertDefect: '不良損失',
    alertDefectDesc: '不良による総損失額です。',
    orderFulfill: '受注充足状況',
    orderTotal: '総受注',
    orderFulfilled: '充足',
    orderShortage: '不足',
    fulfillRate: '充足率',
    vendorPerf: 'サプライヤー実績',
    items: '品目',
    count: '件',
    won: '円',
    day: '日',
    ea: 'EA',
    pcs: '個',
  },

  // 共通テーブル/グリッド
  grid: {
    add: '行追加',
    delete: '削除',
    copy: 'コピー',
    export: 'エクスポート',
    undo: '元に戻す',
    redo: 'やり直す',
    selectedRows: '行選択中',
    noRows: 'データがありません',
  },

  // 資材管理
  materials: {
    title: '資材マスター',
    code: '品目コード',
    name: '品目名',
    group: 'グループ',
    unit: '単位',
    cost: '原価',
    status: 'ステータス',
    active: '有効',
  },

  // 在庫状況
  inventory: {
    title: '在庫状況',
    code: '品目コード',
    name: '品目名',
    group: 'グループ',
    good: 'Good',
    reserved: 'Reserved',
    defect: 'Defect',
    atp: 'ATP',
    cost: '単価',
    value: '在庫価値',
    lossAmt: '損失額',
    status: 'ステータス',
    needOrder: '要発注',
    normal: '正常',
    caution: '注意',
  },

  // 受注管理
  orders: {
    title: '受注管理',
    orderId: '受注番号',
    customer: '顧客',
    itemCode: '品目コード',
    qty: '数量',
    rule: 'ルール',
    date: '日付',
    shortage: '不足',
    fulfilled: '充足',
    unfulfilled: '未充足',
  },

  // サプライヤー
  vendors: {
    title: 'サプライヤー',
    vendorName: 'サプライヤー名',
    code: '品目コード',
    name: '品目名',
    moq: 'MOQ',
    lot: 'LOT',
    cost: '単価',
    lt: 'リードタイム',
    defRate: '不良率',
  },

  // レポート
  reports: {
    inventory: '在庫総合分析',
    inventoryDesc: 'AI在庫分析',
    vendor: 'サプライヤー実績',
    vendorDesc: 'AIサプライチェーン評価',
    order: '受注充足/発注依頼',
    orderDesc: 'AI受注分析',
    defect: '不良/損失分析',
    defectDesc: 'AI品質分析',
    simulation: 'シミュレーション',
    simulationDesc: 'AIシナリオレポート',
    printPdf: '印刷 / PDF',
    aiAnalysis: 'AI分析実行',
    analyzing: '分析中...',
    aiDesc: '上のボタンをクリックすると、AIが現在のデータを分析し\nインサイトと改善提案を提供します。',
    generateReport: 'AIレポート生成',
    generating: 'レポート生成中...',
    simTitle: '在庫シミュレーション レポート生成',
    simDesc: 'シナリオを設定しレポートを生成すると、AIが経営者向け分析レポートを自動作成します。',
    demandChange: '需要変動',
    ltChange: 'リードタイム変動',
    defRateChange: '不良率変動',
    costChange: '単価変動',
    presetDemandSurge: '📈 需要急増 (+30%)',
    presetSupplyDelay: '🚚 供給遅延シナリオ',
    presetQualityDown: '🔴 品質悪化',
    presetInflation: '💰 インフレーション',
    presetWorstCase: '⚠️ 最悪のケース',
    presetImprove: '✅ 改善シナリオ',
    generatedReport: '生成されたレポート',
    dataAnalysis: '📊 データ分析',
    simExecution: '🧮 シミュレーション実行',
    reportWriting: '📝 レポート作成',
    reviewDone: '✅ レビュー完了',
  },

  // レポート詳細 (ReportsPage 内部)
  rpt: {
    // 共通
    group: '品目グループ',
    code: '品目コード',
    name: '品目名',
    count: '品目数',
    qty: '数量',
    unit: '単価',
    total: '合計',
    grade: '等級',
    items: '個',
    cases: '件',
    day: '日',
    won: '円',
    // 在庫
    invTitle: '📊 在庫総合分析レポート',
    totalItems: '総品目',
    goodInv: 'Good 在庫',
    reserved: 'Reserved',
    defect: 'Defect',
    assetValue: '資産価値',
    defLoss: '不良損失',
    groupInv: 'グループ別在庫状況',
    statusDist: '在庫ステータス分布',
    needOrderItems: '要発注品目',
    needOrder: '要発注',
    normal: '正常',
    caution: '注意',
    // サプライヤー
    vendorTitle: '🤝 サプライヤー実績分析レポート',
    vendor: 'サプライヤー',
    tradeCount: '取引',
    avgCost: '平均単価',
    avgLt: '平均リードタイム',
    avgDefRate: '平均不良率',
    tradeDetail: '取引詳細',
    // 受注
    orderTitle: '🛒 受注充足分析および購買依頼書',
    totalOrder: '総受注',
    fulfilled: '充足',
    unfulfilled: '未充足',
    estOrder: '予想発注',
    orderAnalysis: '受注別分析',
    customer: '顧客',
    shortage: '不足',
    rule: 'ルール',
    autoPoTitle: '📝 自動購買依頼書',
    recommended: '推奨先',
    orderQty: '発注量',
    amount: '金額',
    delivery: '納期',
    buyRule: '購買ルール',
    // 不良
    defTitle: '📉 不良/損失分析レポート',
    defItems: '不良品目',
    totalDef: '総不良',
    totalLoss: '総損失',
    groupDef: 'グループ別不良',
    defDetail: '詳細（損失額順）',
    ratio: '割合',
    // シミュレーション
    simTitle: '🧪 在庫シミュレーション レポート生成',
    simDesc: 'シナリオを設定しレポートを生成すると、AIが経営者向け分析レポートを自動作成します。',
    demandLabel: '📈 需要変動',
    ltLabel: '🚚 リードタイム変動',
    defRateLabel: '🔴 不良率変動',
    costLabel: '💰 単価変動',
    generateBtn: 'AIレポート生成',
    generating: 'レポート生成中...',
    genReport: '📄 生成されたレポート',
    aiAnalysisBtn: 'AI分析実行',
    aiAnalyzing: '分析中...',
    aiAnalysisLabel: 'AI分析',
    aiPlaceholder: '上のボタンをクリックすると、AIが現在のデータを分析し\nインサイトと改善提案を提供します。',
    analyzing: 'データを分析しています...',
    printPdf: '🖨️ 印刷 / PDF',
    // シミュレーション プリセット
    presetDemandSurge: '📈 需要急増 (+30%)',
    presetSupplyDelay: '🚚 供給遅延シナリオ',
    presetQualityDown: '🔴 品質悪化',
    presetInflation: '💰 インフレーション',
    presetWorstCase: '⚠️ 最悪のケース',
    presetImprove: '✅ 改善シナリオ',
    // シミュレーション 進行段階
    stepAnalysis: '📊 データ分析',
    stepSimulation: '🧮 シミュレーション実行',
    stepWriting: '📝 レポート作成',
    stepReview: '✅ レビュー完了',
    // 通貨/単位
    currencySymbol: '¥',
    // AI プロンプト言語
    promptLang: 'ja',
  },

  // コパイロット
  copilot: {
    title: 'AIコパイロット',
    subtitle: '品目 · リアルタイム分析',
    placeholder: '質問を入力してください...',
    thinking: '考え中...',
    welcomeTitle: '何をお手伝いしましょうか？',
    welcomeSub: '品目コード、在庫、発注、サプライヤーなどを質問してください',
    open: 'AIコパイロットを開く',
    clear: 'チャットをクリア',
    expand: '拡張',
    collapse: '縮小',
    close: '閉じる',
    homepage: 'ホームページを開く',
    notFound: 'ご質問に関するデータが見つかりませんでした。\n\n以下の質問をお試しください:\n- 在庫状況を全部教えて\n- 発注が必要なものを教えて\n- P101011の在庫を教えて',
    prompts: {
      dashboard: ['発注が必要な品目を教えて', '不良損失額を分析して', '可用在庫(ATP)現況を教えて', '購買依頼書を作成して'],
      materials: ['メモリグループの品目を見せて', '非メモリ品目を見せて', 'CSP系列のサプライヤー情報を見せて', 'P101011の情報を教えて'],
      inventory: ['在庫状況を全部教えて', '発注が必要なものリスト', '不良在庫リストをちょうだい', 'P202012の在庫を教えて'],
      orders: ['注文から購買依頼書を作成して', '注文充足状況を教えて', 'P301011の在庫を教えて'],
      suppliers: ['サプライヤー状況を教えて', 'P301024の発注先情報', 'P101011のサプライヤーを比較して'],
    },
  },

  // 設定ページ
  settings: {
    title: '設定',
    desc: 'システム設定とユーザー権限を管理できます。',
    language: '言語設定',
    langDesc: 'インターフェース言語を変更します。',
  },
};

export default ja;
